export default "__VITE_ASSET__CrMNa4ZY__"